interface CardImageSizesResponse {
  large: string
  medium: string
  small: string
}

class CardImageSizesModel {
  public large: string
  public medium: string
  public small: string

  public constructor(data: CardImageSizesResponse) {
    this.large = data.large
    this.medium = data.medium
    this.small = data.small
  }
}

export interface CardImageResponse {
  contentType: string
  id: string
  urls: CardImageSizesResponse
  textColorRGBA: string
  hasTextShadow: boolean
  shadowTextColorRGBA?: string
}

export class CardImageModel {
  public contentType: string
  public id: string
  public urls: CardImageSizesModel
  public textColorRGBA: string
  public hasTextShadow: boolean
  public shadowTextColorRGBA?: string

  public constructor(data: CardImageResponse) {
    this.contentType = data.contentType
    this.id = data.id
    this.urls = data.urls
    this.textColorRGBA = data.textColorRGBA
    this.hasTextShadow = data.hasTextShadow
    this.shadowTextColorRGBA = data.shadowTextColorRGBA
  }
}
